import React, {  } from 'react'

import { Helmet } from 'react-helmet';
function Carrer() {

  return (
    <div>
      <Helmet>
  <link rel="canonical" href="https://ayn-solutions.vercel.app/Careers" />
  <title>Start Your Career with Ayn Solutions!</title>
  <meta name="description" content="Explore exciting tech career opportunities at Ayn Solutions. Join our dynamic team and contribute to empowering success through innovative IT solutions. Check our current job openings and take the next step in your career with us." />
</Helmet>


      <div className="bg-gradient-to-b from-gray-700 to-gray-900 h-[400px] overflow-hidden ">
        <div className="flex flex-col-reverse lg:flex-row justify-between lg:gap-2">
          <div

            className=" justify-center  lg:ps-10 flex flex-col gap-6">
            <h1 className="text-[#D1D5DB] text-center font-semibold font-[raleway] mt-5 lg:mt-0 text-2xl lg:text-5xl">
              Get in Touch with Ayn Solutions
            </h1>
            <p className="text-white mb-10 lg:mb-0 text-center lg: lg:text-start font-[poppins] text-sm lg:w-[750px] lg:ps-10 ">
            At Ayn Solutions, we understand the power of collaboration in achieving business goals. Partnering with us strengthens your organization and propels you toward outstanding success. If you’re ready to discover how strategic human resource solutions can transform your business, reach out to us today!
            </p>
          </div>

          <svg

            focusable="false"
            className="hero__honeycom lg:h-[370px] h-[120px] lg:w-[320px] "
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 308.72 465.51"
          >
            <title>qti-inside-page-honeycomb-desktop</title>
            <path
              d="M245.36,34.33,185.9,0,126.44,34.33V103l59.46,34.33L245.36,103Z"
              fill="#fff"
            ></path>
            <path
              d="M182.1,143.68l-59.46-34.33L63.18,143.68v68.66l59.46,34.33,59.46-34.33Z"
              fill="#fff"
            ></path>
            <path
              d="M308.61,143.68l-59.46-34.33-59.46,34.33v68.66l59.46,34.33,59.46-34.33Z"
              fill="#fff"
            ></path>
            <path
              d="M118.92,253.2,59.46,218.87,0,253.2v68.66l59.46,34.33,59.46-34.33Z"
              fill="#fff"
            ></path>
            <path
              d="M245.46,253.2,186,218.87,126.54,253.2v68.66L186,356.19l59.46-34.33Z"
              fill="#fff"
            ></path>
            <path
              d="M308.72,362.52l-59.46-34.33L189.8,362.52v68.66l59.46,34.33,59.46-34.33Z"
              fill="#fff"
            ></path>
          </svg>
        </div>
      </div>

      <div

        className="bg-gray-100 mb-10 mt-10 p-8 rounded-lg shadow-md">
        <h2 className="text-3xl font-semibold mb-4">Wanted at Ayn Solutions</h2>
        <p className="text-gray-700">
        Join our dynamic team as an HR Specialist! We’re seeking an experienced professional with a passion for recruitment, employee relations, and fostering a positive workplace culture. </p>
        <ul className="mt-4">
          <li className="flex items-center">
            <svg className="w-6 h-6 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 13l4 4L19 7"></path>
            </svg>
            Manage the complete recruitment process from sourcing to onboarding.
          </li>
          <li className="flex items-center mt-2">
            <svg className="w-6 h-6 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 13l4 4L19 7"></path>
            </svg>
            Develop and implement effective HR policies and procedures.          </li>
          <li className="flex items-center mt-2">
            <svg className="w-6 h-6 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 13l4 4L19 7"></path>
            </svg>
            Collaborate with teams to boost employee engagement and satisfaction.          </li>
        </ul>
        <p className="text-gray-700 mt-4">
        If you're ready to make a difference in our organization, apply now by sending your resume and cover letter to  <a href="mailto:Aynsolutions@gmail.com."
            className="text-blue-500">Aynsolutions@gmail.com.</a>
        </p>
      </div>
    </div>
  )
}

export default Carrer